import { render, staticRenderFns } from "./EditCategorie.vue?vue&type=template&id=0843c47c&"
import script from "./EditCategorie.vue?vue&type=script&lang=js&"
export * from "./EditCategorie.vue?vue&type=script&lang=js&"
import style0 from "./EditCategorie.vue?vue&type=style&index=0&id=0843c47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports